import { EyengagePost, TagsData } from "src/shared/types/src";
import { useAppDispatch } from "../../../services/store";
import LikeCommentFooter from "../../../components/LikeCommentFooter";
import PostDescriptionComponent from "./PostDescriptionComponent";
import ConfirmPostComponent from "./ConfirmPostComponent";
import PostPollContainer from "./PostPollContainer";
import LinkPreviewComponent from "./LinkPreviewComponent";
import { TagListRenderer, MediaCollageContainer, PostAndObservationHeader } from "src/app/components";
import { ENTITY_TYPE, EYENGAGE_POST_TYPES } from "src/shared/config/src/lib/constants";
import { EyengageActions } from "src/shared/redux-state/src/lib/eyengage/EyengageSlice";
import { AppRoutes } from "src/app/navigation/routes";
import { useNavigate } from "react-router-dom";
import EventDetails from "./EventDetails";

export default function PostContainer({ eyengagePost }: { eyengagePost: EyengagePost }) {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const handleLikeUnlike = async ({ likeCount, likedBySelf }: { likeCount: number, likedBySelf: boolean }) => {
        await dispatch(EyengageActions.updateLikeCountInPostById({ postId: eyengagePost.id, updatedLikeCount: likeCount, likedBySelf }));
    }

    const handleAddComment = async () => {
        await dispatch(EyengageActions.updateCommentCountInPostById({ postId: eyengagePost.id, updatedCommentCount: eyengagePost.comments.count + 1 }));
    }

    return (
        <>
            <PostAndObservationHeader name={eyengagePost.addedBy.name} photo={eyengagePost.addedBy.photo} date={eyengagePost.date} />
            <TagListRenderer tags={[{ color: eyengagePost.category.color, label: eyengagePost.category.name } as TagsData]} />
            {(eyengagePost.type === EYENGAGE_POST_TYPES.EVENT) && <EventDetails postData={eyengagePost} />}
            <PostDescriptionComponent postData={eyengagePost} descriptionText={eyengagePost.description} />
            {(eyengagePost?.linkPreview) ? <LinkPreviewComponent linkPreview={eyengagePost.linkPreview} /> : null}
            {(eyengagePost?.poll?.options?.length > 0) ? <PostPollContainer postData={eyengagePost} /> : null}

            {(eyengagePost?.attachments?.length > 0) ?
                <MediaCollageContainer
                    media={eyengagePost.attachments}
                    openCarousel={false}
                    onMediaGroupClick={() => navigate(`${AppRoutes.EYENGAGE_POST_DETAILS}/${eyengagePost.id}`)}
                /> : null}

            {(eyengagePost?.confirmationRequired) ?
                <ConfirmPostComponent
                    confirmedAt={eyengagePost.confirmedAt}
                    confirmationStatus={eyengagePost.confirmedByMe}
                    postId={eyengagePost.id} /> : null}

            {(!eyengagePost?.disableReactions) ?
                <LikeCommentFooter
                    likedByMe={eyengagePost?.likes?.self}
                    likeCount={eyengagePost?.likes?.count || 0}
                    commentCount={eyengagePost?.comments?.count || 0}
                    entityType={ENTITY_TYPE.EYENGAGE}
                    entityId={eyengagePost?.id}
                    onLikeUnlike={handleLikeUnlike}
                    onAddComment={handleAddComment}
                    customLikeCommentStyle={'pd-t-0 border-0'}
                /> : null
            }
        </>
    )
}